import script from "./EmployeeSeal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeSeal.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeSeal.vue?vue&type=style&index=0&id=84a2626e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84a2626e"]])

export default __exports__